import { render, staticRenderFns } from "./SerialManagementDialog.vue?vue&type=template&id=0f5f1a66&scoped=true&"
import script from "./SerialManagementDialog.vue?vue&type=script&lang=js&"
export * from "./SerialManagementDialog.vue?vue&type=script&lang=js&"
import style0 from "./SerialManagementDialog.vue?vue&type=style&index=0&id=0f5f1a66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f1a66",
  null
  
)

export default component.exports